import React, { useState, useEffect } from 'react'
import { Row, Form, Button, Col } from 'react-bootstrap';
import {  useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useReactMediaRecorder } from "react-media-recorder"
import fixWebmDuration from 'webm-duration-fix';
import { toast } from 'react-toastify';
import { useUpdateQuestionWatchedMutation } from '../../slices/teachers/teacherQuestionsApiSlice';
import TeacherHeader from '../../components/TeacherHeader';
import TeacherNavbar from '../../components/TeacherNavbar';
import Loader from '../../components/Loader';
import Message from '../../components/Message';

const TeacherScreen = () => {

    const mimeType = 'video/webm\;codecs=vp9';
    const navigate = useNavigate();

    const { id } = useParams();

    const [showVideo, setshowVideo] = useState(false);
    const [showRecordButtons, setshowRecordButtons] = useState(true);
    const [showStopButtons, setshowStopButtons] = useState(false);

    const { teacherInfo } = useSelector((state) => state.authTeacher);
    const [updateQuestionWatched] = useUpdateQuestionWatchedMutation();

    useEffect(() => {
        if(!teacherInfo) {
            navigate('/teacherlogin')
        }
    }, [navigate, teacherInfo])

    async function getString(mediaBlobUrl) {
        const mediaBlob = await fetch(mediaBlobUrl)
            .then(response => response.blob());
                const fixBlob = await fixWebmDuration(new Blob([mediaBlob], { type: mimeType }));            
                var fd = new FormData();
                fd.append('upl', fixBlob,);
                fd.append('id', id);
                fetch('/api/upload/answer',
                {
                    method: 'post',
                    body:fd                    
                }) 
    }

    const { status, startRecording, stopRecording, mediaBlobUrl } = useReactMediaRecorder({ 
            video: true,
            screen: true, 
            onStart: () => {
                setshowStopButtons(true)
                setshowRecordButtons(false)
            },
            onStop: (blobUrl, blob) => {
                getString(blobUrl) 
                setshowVideo(true)
                setshowRecordButtons(false)
                setshowStopButtons(false)
                const res =  updateQuestionWatched(id).unwrap();
            }            
        }
    );

  return (
    <div>
        <TeacherNavbar />
        <div className="main-content" id="panel">
            <TeacherHeader />       
            <div className="container-fluid mt--6">
                <div className="row">
                {showRecordButtons ? ( 
                    <>
                    <div className="offset-xl-1 col-xl-10">   
                        <h5 className="h3 card-title mb-0 mycard">
                        <h4 className="tittleColor4 recordTittle">
                            Click on Record Screen  and choose a tab or entire screen to start recording
                        </h4>
                        <br /> 
                        </h5>
                        </div>
                        <div className="offset-xl-4 col-xl-4 " onClick={startRecording}>   
                            <div className="card rounded-pill mouseP">
                            <div className="card-body recordVid33">
                            <div className="row">
                            <div className="sidenav-header   recordButt33 col-xl-4" >
                                <img src="../../assets/img/rec3.png" className="navbar-brand-img recordButt33 recordButt334"  style={{ height: "100%"}}  />
                            </div>
                            <div className="col recordButton33 col-xl-8">
                                <span  className="h2 font-weight-bold mb-0 tittleColor4 recordButton33 recordVid332">Record Screen</span>
                            </div>
                            </div>
                            </div>
                            </div>
                        </div>
                        </>  
                ) : ( 
                <p></p>
                )} 
                {showStopButtons ? ( 
                    <div className="">
                        <div className="offset-xl-3 col-xl-6 recordButt35">   
                            <div className="sidenav-header   recordButt2" >
                                <img src="../../assets/img/rec4.gif" className="navbar-brand-img recordButt2 recProg"  style={{ height: "400%"}}  />
                            </div><br /><br /><br /><br /><br /><br /><br />
                        </div>
                        <div className="offset-xl-4 col-xl-4" onClick={stopRecording}>   
                            <div className="card rounded-pill  mouseP">
                            <div className="card-body recordVid34">
                            <div className="row">
                            <div className="sidenav-header  recordButt33 col-xl-4" >
                                <img src="../../assets/img/stop1.png" className="navbar-brand-img recordButt33 "  style={{ height: "90%"}}  />
                            </div>
                            <div className="col  col-xl-8 stopR">
                                <span  className="h5 font-weight-bold mb-0 stopR2 tittleColor4  recordVid333">Stop recording</span>
                            </div>
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>  
                ) : ( 
                    <p></p>
                )} 
                {showVideo ? ( 
                    <div className="col-xl-10 offset-xl-1"> 
                        <br /><br /><br /><br /> 
                        <div className="card mycard">
                            <video className="card-img-top" src={mediaBlobUrl} controls autoPlay loop />
                            <div className="card-body "><br /><br />
                                <LinkContainer to={`/teacheranswertype/${id}`} className='btn btn-danger '>
                                    <Button variant="primary  bg-gradient-danger" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-info' > &nbsp; Record Again &nbsp; </Button>
                                </LinkContainer>&nbsp; &nbsp;
                                <LinkContainer to={`/teachernewquestions`} className='btn btn-success '>
                                    <Button variant="primary  bg-gradient-success" className=' btn btn-primary btn-lg  rounded-pill bg-gradient-success'>&nbsp; Save Video &nbsp; </Button>
                                </LinkContainer>                    
                            </div>
                        </div>
                    </div>
                ) : ( 
                    <p></p> 
                )} 
            </div>
            </div>
        </div>
    </div>
  )
}

export default TeacherScreen
